export const REQUEST_LOTTERIES = 'LOTTERIES/REQUEST_LOTTERIES';
export const RECEIVE_LOTTERIES = 'LOTTERIES/RECEIVE_LOTTERIES';
export const SELECT_LOTTERY = 'LOTTERIES/SELECT_LOTTERY';